import {useNavigate} from 'react-router-dom';
import defaultImg from '../../../../assets/image/newShop/defaultImg.png';

const SaleAgentCard = ({data}: {data: IStoreSaleAgent}) => {
  const navigate = useNavigate();

  return (
    <div className="border rounded-2xl p-3 space-y-3 shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center justify-center gap-2">
          <img
            src={data?.logo ?? defaultImg}
            alt={data?.title}
            className="w-9 h-9 rounded-full object-cover"
          />
          <span className="text-md font-medium text-gray-950">
            {data?.title}
          </span>
        </div>
        <i
          className="icon-nameArrow---Left-2 text-xl text-gray-700"
          onClick={() => navigate(`/shop-card-detail/${data?.guid}`)}
        />
      </div>

      {!!data?.address ? (
        <div className="flex items-start mr-2">
          <i className="icon-nameLocation text-gray-700 text-xl" />
          <span className="text-sm text-gray-800 mr-2">{data?.address}</span>
        </div>
      ) : null}

      <div
        className="flex items-center mr-2"
        onClick={() => (window.location.href = `tel:${data?.phone_number}`)}
      >
        <i className="icon-namecall text-farm-shop-500 text-xl" />
        <span className="text-sm text-farm-shop-500 mr-2">
          0{data?.phone_number.slice(2)}
        </span>
      </div>
    </div>
  );
};

export default SaleAgentCard;
